export const environment = {
  production: false,
  configuration: "DEVELOP",
  applicationName: "Arquetipo Angular",
  apiUrl: "https://1d4b3aa7-85de-467c-a2b8-af04be2cad38.mock.pstmn.io/api",
  apiUrlCap: "https://cargacursosgb-dev.bimboconnect.com",
  QrUri: "https://cargacursosgb-dev.bimboconnect.com/",
  Azure: {
    GraphEndpoint: "https://graph.microsoft.com/v1.0/me",
    ActiveDirectory: {
      ClientId: "951eb356-c4a9-419e-abf1-437c0a560aec",
      Authority:
        "https://login.microsoftonline.com/973ba820-4a58-4246-84bf-170e50b3152a",
      RedirectUri: "https://cargacursosgb-dev.bimboconnect.com/",
      RedirectUriLogout:
        "https://cargacursosgb-dev.bimboconnect.com/#/login?returnUrl=%2Fhome",
      RedirectUriLogoutAttendance:
        "https://cargacursosgb-dev.bimboconnect.com/#/registrarAsistencia",
    },
  },
  botEmail: "rpauipath042@grupobimbo.com",
};
